// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fe4d9a74","239":"2846a851","453":"404bf714","732":"7982b4a8"}[chunkId] + ".chunk.js";
};